









import { Vue, Component } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';

@Component({})
export default class TopBarMenu extends Vue {
  opened = false;

  closeMenu() {
    this.opened = false;
  }

  topBarMenuOpen(menu: TopBarMenu) {
    if (menu !== this) {
      this.closeMenu();
    }
  }

  showMenu() {
    this.opened = true;

    eventBus.$emit('topBarMenuOpen', this);
  }

  leaveMenu() {
    this.closeMenu();
  }

  created() {
    eventBus.$on('beforeEachRoute', this.closeMenu);
    eventBus.$on('topBarMenuOpen', this.topBarMenuOpen);
  }

  destroy() {
    eventBus.$off('beforeEachRoute', this.closeMenu);
    eventBus.$off('topBarMenuOpen', this.topBarMenuOpen);
  }
}
